<template>
    <paper>
        <m-pane
            class="ali-service-task"
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :optionNum="optionNum"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            :pickerConfig="config.pickerConfig"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @withdraw-btn="withdrawBtn"
            @search-list-change="searchListChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
            </div>
            <template v-slot:customTableCell="{row, col}">
                <span style="white-space:pre">{{ row[col.prop]}}</span>
            </template>
            <div slot="page-module-btn">
                <span v-has="'02040001'">
                    <el-button type="primary" class="bigData-btn-issue-method" @click="taskDistibute">下 发</el-button>
                </span>
            </div>
        </m-pane>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import {
    getServiceTasksList,
    taskIssue,
    cancel
} from '@otp/api/aliServiceTasks';
import { dateTimes } from '@otp/judge/configCenter';
import bigDataLog from '@/utils/bigDataLog';
import orderDataDict from '@otp/utils/orderDataDict.js';
const { VALUED_ADD, EXCEPTION } = orderDataDict.VALUED_STATUS;
export default {
    name: 'aliServiceTasks',
    components: { mPane, paper },
    data() {
        return {
            config: config,
            loading: false,
            optionNum: '',
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            selectedRows: [],
            tableData: [],
            searchParams: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        searchListChange(config, data) {
            // input批量操作
            if (config.selectConfig && config.selectConfig.option) {
                data = data.replace(/\s+/g, ',');
                const obj = {};
                obj[config.value] = data;
                this.$nextTick(() => {
                    const searchList = this.$refs.tablePage.$refs.searchList;
                    searchList.searchData[config.value] = data;
                    if (config.select && searchList.$refs.searchSet) {
                        let searchSet = searchList.$refs.searchSet;
                        if (Array.isArray(searchSet)) searchSet = searchSet[0];
                        searchSet.searchList[1].data[config.value] = data;
                    }
                });
            }
            this.searchParams[config.value] = data || '';
        },
        rowDBclick(data) {
            const { taskNo, orderStatus, serviceType, createTime } = data;
            this.$router.push({
                path: `/order-manage/ali-service-tasks/edit`,
                query: { taskNo, status: orderStatus, serviceType, createTime }
            });
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectedRows = data;
        },
        searchChange(data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-search-method');
            let startTime, endTime;
            const { MAX_DAY, MAX_MONTH } = this.ORDER_DATA_DICT.SEARCH_TIME_LIMIT;
            if (data.creatTimes && data.creatTimes.length) {
                startTime = dateTimes(data.creatTimes[0]);
                endTime = dateTimes(data.creatTimes[1]);
            }
            // if (data.sourceSystem && !data.vdOrderNo && !(data.creatTimes && data.creatTimes.length)) {
            //     return this.$message.warning('按照来源系统查询时,创建时间必填！');
            // };
            // data找到有值的key
            const keys = Object.keys(data).filter(item => data[item]);
            if (keys.length === 1 && keys.includes('sourceSystem')) {
                return this.$message.warning('只有来源系统查询时,创建时间必填！');
            }
            // if (!(data.vdOrderNo || data.taskNo) && !startTime) {
            //     this.$message.warning('单号 或 时间不可为空！');
            //     return;
            // }
            if (!['relationOrderNo', 'originalOrderNo', 'batchQueryValue', 'taskNo', 'creatTimes'].some(item => keys.includes(item))) {
                return this.$message.warning('单号 或 时间不可为空！');
            }

            if (!(data.vdOrderNo || data.taskNo)) {
                if (new Date(endTime).getTime() - new Date(startTime).getTime() > MAX_DAY) {
                    this.$message.warning(`只有时间查询条件时，查询时间跨度不可超过${MAX_MONTH}个月！`);
                    return;
                }
            }
            const isBatch = data.batchQueryValue && data.batchQueryKey;
            if (isBatch) {
                data.batchQueryValue = data.batchQueryValue = data.batchQueryValue.split(',');
                if (['vdOrderNo','taskNo'].includes(data.batchQueryKey) &&  data.batchQueryValue.length > 100) {
                    return this.$message.warning(`增值单号、任务号, 一次最多查询 100 个`);
                }
            }
            if (data.batchSiteCode) {
                data.batchSiteCode = data.batchSiteCode.split(',');
                data.batchSiteName = data.batchSiteName.split(',');
            }
            delete data.creatTimes;
            this.searchParams = Object.assign({}, {
                pageNo: 1,
                pageSize: this.searchParams.pageSize,
                ...data,
                startTime,
                endTime
            });
            this.loading = true;
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.getList();
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addData();
        },
        getList() {
            getServiceTasksList(this.searchParams).then(res => {
                this.loading = false;
                if (res) {
                    this.totalData = res.data.list.map(val => {
                        val.hiddenEvent = [];
                        val.orderStatus = val.orderStatus + '';
                        // if (+val.orderStatus === 60) val.hiddenEvent.push('withdraw');
                        return val;
                    });
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        // 任务下发
        async taskDistibute() {
            if (this.selectedRows.length <= 0) return this.$message.warning('请至少选择一条数据');
            const noExamineArr = this.selectedRows.filter(item => ![VALUED_ADD, EXCEPTION].includes(+item.orderStatus)).map(v => v.vdOrderNo);
            if (noExamineArr.length === 1) return this.$message.warning(`【${noExamineArr.join(',')}】不能下发，新增和异常状态的单才能下发`);
            if (noExamineArr.length > 1) return this.$message.warning(`存在【${noExamineArr.join(',')}】不允许进行下发，请仔细核实！！`);
            const res = await taskIssue(
                this.selectedRows.map(i => i.taskNo)
            );
            if (res && res.code === '0') {
                this.$message.success('已下发');
                this.getList();
            }
        },
        withdrawBtn(data) {
            const params = {
                code: data.taskNo,
                type: 20
            };
            cancel(params).then(res => {
                if (res) {
                    this.$message.success('撤回成功');
                    this.getList();
                }
            });
        }
    }
};
</script>
<style lang="less">
</style>
